module.exports = __webpack_public_path__ + "DINNextLTPro-Black.woff2?c893521aa2a9d95399a3891435928b81";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Black.woff2
// module id = 1439
// module chunks = 0